export default __webpack_public_path__ + "static/media/homeSelected.ea8096cd.svg";